export { default } from './SWTariffCard';
